import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import useApi from "../../../core/customhook/useApi";
import Swal from "sweetalert2";
import { getFinancialYearList } from "../../../core/common/financialYear";

const GoalSummary = () => {
  const getCurrentFinancialYear = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth();
    const fyStart = month >= 3 ? year : year - 1;
    const nextYearShort = (fyStart + 1).toString().slice(-2);
    return `${fyStart}-${nextYearShort}`;
  };
  const [finance_year, setFinance_year] = useState(getCurrentFinancialYear());
  const [allItemList, setAllItemList] = useState<any>({});
  const [count, setCount] = useState(0);
  const navigate = useNavigate();
  const {
    data: getcategoryResponse,
    loading: getCategoryLoading,
    error: getCategoryError,
  } = useApi("/api/manager/view-category", {
    method: "POST",
    payload: {
      financial_year: finance_year,
    },
    autoCall: true,
    dependencies: [count, finance_year],
  });

  useEffect(() => {
    setAllItemList(getcategoryResponse?.data);
  }, [getcategoryResponse]);

  const addCategoryID = (
    category_id: any,
    category_name: any,
    financial_year: string,
    navi: string,
  ) => {
    console.log(category_id, category_name, navi, financial_year);
    localStorage.setItem("pms_category_id", category_id);
    localStorage.setItem("pms_category_name", category_name);
    if (navi === "KRA") {
      navigate(`/pms-kra-profile/${financial_year}`);
    } else if (navi === "BEHA") {
      navigate(`/pms-behavioural-Competence/${financial_year}`);
    } else if (navi === "GOAL") {
      navigate(`/pms-career-aspirations/${financial_year}`);
    }
  };
  const {
    data: deletecategoryResponse,
    loading: deleteCategoryLoading,
    error: deleteCategoryError,
    callApi: deleteCategoryData,
  } = useApi("", {
    method: "DELETE",
    autoCall: false,
  });
  const DeleteItem = async (ID: any) => {
    const confirmResult = await Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this Goal Profile? This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });

    if (confirmResult.isConfirmed) {
      try {
        const response = await deleteCategoryData(
          undefined,
          "/api/manager/delete-category/" + ID,
        );

        if (response.success) {
          Swal.fire({
            title: "Deleted!",
            text:
              response?.message || "Category has been deleted successfully.",
            icon: "success",
            confirmButtonText: "OK",
          });
          setCount(count + 1);
        }
      } catch (error) {
        console.error("Error while deleting:", error);
        Swal.fire({
          title: "Error!",
          text: "There was a problem deleting the category.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    }
  };
  const clearCategoryId = () => {
    localStorage.removeItem("pms_category_id");
    localStorage.removeItem("pms_category_name");
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
          <div className="my-auto mb-2">
            <h2 className="mb-1">Create Goals</h2>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={all_routes.adminDashboard}>
                    <i className="ti ti-smart-home" />
                  </Link>
                </li>
                <li className="breadcrumb-item">Work & Operations</li>
                <li className="breadcrumb-item">PMS</li>
                <li className="breadcrumb-item">
                  <Link to={all_routes.pmsGrid}>Goal Settings</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Create Goals
                </li>
              </ol>
            </nav>
          </div>
          <div className="d-flex gap-2">
            {allItemList ? null : (
              <div>
                <Link
                  to={`/pms-goals-profile/${finance_year}`}
                  className="btn btn-primary custom_button"
                  onClick={clearCategoryId}
                >
                  Goal Profile
                </Link>
              </div>
            )}
            <div className="d-flex gap-2">
              <select
                value={finance_year}
                onChange={(e) => setFinance_year(e.target.value)}
                className="form-select"
              >
                {getFinancialYearList().map((fy) => (
                  <option key={fy} value={fy}>
                    {fy}
                  </option>
                ))}
              </select>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
        </div>
        <div className="card">
          <div className="card-header">
            <h5>Goals Summary</h5>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-bordered table-hover">
                <thead className="table-light">
                  <tr>
                    <th>S No</th>
                    <th>Goal Profile</th>
                    {/* <th>Goal Profile Description</th> */}
                    <th>KRA</th>
                    <th>Behavioural Competency</th>
                    <th>Career Aspirations</th>
                    <th>Status</th>
                    <th>Action</th>
                    <th>Reject Reason</th>
                  </tr>
                </thead>
                <tbody>
                  {allItemList && (
                    <tr>
                      <td>1</td>
                      <td>{allItemList.category_name}</td>

                      <td>
                        <button
                          onClick={() =>
                            addCategoryID(
                              allItemList.category_id,
                              allItemList.category_name,
                              allItemList.financial_year,
                              "KRA",
                            )
                          }
                          className="text-primary text-decoration-underline p-0 border-0 bg-transparent"
                        >
                          Edit/View
                        </button>
                      </td>

                      <td>
                        <button
                          onClick={() =>
                            addCategoryID(
                              allItemList.category_id,
                              allItemList.category_name,
                              allItemList.financial_year,
                              "BEHA",
                            )
                          }
                          className="text-primary text-decoration-underline p-0 border-0 bg-transparent"
                        >
                          Edit/View
                        </button>
                      </td>

                      <td>
                        <button
                          onClick={() =>
                            addCategoryID(
                              allItemList.category_id,
                              allItemList.category_name,
                              allItemList.financial_year,
                              "GOAL",
                            )
                          }
                          className="text-primary text-decoration-underline p-0 border-0 bg-transparent"
                        >
                          Edit/View
                        </button>
                      </td>
                      <td>
                        <span
                          className={`badge ${
                            allItemList?.status
                              ?.toLowerCase()
                              .includes("approved")
                              ? "bg-success"
                              : allItemList?.status
                                    ?.toLowerCase()
                                    .includes("rejected")
                                ? "bg-danger"
                                : "bg-warning"
                          }`}
                        >
                          {allItemList.status}
                        </span>
                      </td>

                      <td>
                        <button
                          className="text-danger p-0 border-0 bg-transparent"
                          title="Delete"
                          onClick={() => DeleteItem(allItemList.category_id)}
                        >
                          <i className="ti ti-trash"></i>
                        </button>
                      </td>

                      <td>{allItemList.reject_reason ?? "-"}</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        {/* Footer */}
      </div>
      <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3 mt-4">
        <p className="mb-0">
          © {new Date().getFullYear()} WeConnect. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default GoalSummary;
